var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "limits" },
    [
      !_vm.listLoaded
        ? [
            _c(
              "div",
              { staticClass: "limits__loader" },
              [
                _c("md-progress-spinner", {
                  attrs: { "md-mode": "indeterminate" }
                })
              ],
              1
            )
          ]
        : _vm._l(Object.keys(_vm.accountBalances), function(asset, i) {
            return [
              _c("div", { staticClass: "container-header" }, [
                _c("div", { staticClass: "container-header__title" }, [
                  _vm._v(
                    _vm._s(_vm.assetName(asset)) + " (" + _vm._s(asset) + ")"
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "md-card",
                { key: i, staticClass: "container container_40" },
                [
                  _c(
                    "md-table",
                    { staticClass: "limits-table scrollbar" },
                    [
                      _c(
                        "md-table-row",
                        { staticClass: "limits__row" },
                        [
                          _c("md-table-head", [
                            _vm._v(
                              _vm._s(_vm.i18n.lim_transaction_type_title())
                            )
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _c("div", [_vm._v(_vm._s(_vm.i18n.lim_one_time()))])
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _c("div", [_vm._v(_vm._s(_vm.i18n.lim_daily()))]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.i18n.lim_left_total()))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _c("div", [_vm._v(_vm._s(_vm.i18n.lim_weekly()))]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.i18n.lim_left_total()))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _c("div", [_vm._v(_vm._s(_vm.i18n.lim_monthly()))]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.i18n.lim_left_total()))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _c("div", [_vm._v(_vm._s(_vm.i18n.lim_annual()))]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.i18n.lim_left_total()))
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(Object.entries(_vm.transactionTypes), function(
                        ref,
                        idx
                      ) {
                        var operation = ref[0]
                        var name = ref[1]
                        return [
                          _c(
                            "md-table-row",
                            { key: i, staticClass: "limits-table__row" },
                            [
                              _c(
                                "md-table-cell",
                                {
                                  staticClass: "text_large limits-table__type"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      operation ===
                                        _vm.transactionTypes.withdrawal
                                        ? _vm.i18n.tx_withdrawal()
                                        : _vm.i18n.tx_transfer()
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "text_medium" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(
                                          i,
                                          operation,
                                          "operation"
                                        )
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "operation"
                                            )["amount_limit"]
                                          : "-"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "text_medium" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(i, operation, "day")
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "day"
                                            )["amount"]
                                          : "-"
                                      ) +
                                      "\n              /\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(i, operation, "day")
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "day"
                                            )["amount_limit"]
                                          : "-"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "text_medium" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(i, operation, "week")
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "week"
                                            )["amount"]
                                          : "-"
                                      ) +
                                      "\n              /\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(i, operation, "week")
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "week"
                                            )["amount_limit"]
                                          : "-"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "text_medium" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(i, operation, "month")
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "month"
                                            )["amount"]
                                          : "-"
                                      ) +
                                      "\n              /\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(i, operation, "month")
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "month"
                                            )["amount_limit"]
                                          : "-"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "text_medium" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(i, operation, "year")
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "year"
                                            )["amount"]
                                          : "-"
                                      ) +
                                      "\n              /\n              " +
                                      _vm._s(
                                        _vm.getLimitValue(i, operation, "year")
                                          ? _vm.getLimitValue(
                                              i,
                                              operation,
                                              "year"
                                            )["amount_limit"]
                                          : "-"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab20cb5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab20cb5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/limits/Limits.Index.vue
// module id = u3Co
// module chunks = 1